// 日期格式化插件
import moment from "moment"

// 时间格式化处理
const time = function(data){
    return moment(data).format("YYYY-MM-DD HH:mm:ss")
}


export default time



